module.exports = __webpack_public_path__ + "static/media/heart-regular.311b7fc9.svg";